<template>
    <breeze-authenticated-layout>
        <template #header>
            <h2 class="font-semibold text-3xl text-gray-800 leading-tight py-2">
                Profile
            </h2>
        </template>

        <breeze-page>
            <div class="grid grid-cols-2 gap-2">
                <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
                    <p class="text-lg font-medium mb-4">Profile</p>
                    <loading :showLoading="form.processing" />
                    <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                        <form @submit.prevent="submitForm">
                            <div class="grid grid-cols-8 gap-4 mb-4">
                                <div class="col-span-4 sm:col-span-4">
                                    <breeze-label :value="'Name'"/>
                                    <breeze-input required v-model="form.name" class="w-full"/>
                                    <breeze-input-error :message="form.errors.profile?form.errors.profile.name:''" />
                                </div>
                                <div class="col-span-4 sm:col-span-4">
                                    <breeze-label :value="'Mobile'"/>
                                    <breeze-input required type="number" v-model="form.mobile" class="w-full"/>
                                    <breeze-input-error :message="form.errors.profile?form.errors.profile.mobile:''" />
                                </div>
                                <div class="col-span-8 sm:col-span-8">
                                    <breeze-label :value="'Email'"/>
                                    <breeze-input required v-model="form.email" class="w-full"/>
                                    <breeze-input-error :message="form.errors.profile?form.errors.profile.email:''" />
                                </div>
                                
                            </div>
                            <breeze-button :disabled="form.processing">Save</breeze-button>
                            <exception />
                            <span v-show="form.recentlySuccessful" class="text-green-800 mx-4 text-sm">Profile Updated</span>
                        </form>
                    </div>
                </div>
                <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
                    <p class="text-lg font-medium mb-4">Change Password</p>
                    <div v-if="!form.processing">
                        <form @submit.prevent="changePassword">
                            <div class="grid grid-cols-8 gap-4 mb-4">
                                <div class="col-span-8 sm:col-span-8">
                                    <breeze-label :value="'Old Password'"/>
                                    <breeze-input required type="password" v-model="passwordForm.old_password" class="w-full"/>
                                    <breeze-input-error :message="passwordForm.errors.changePassword?passwordForm.errors.changePassword.old_password:''" />
                                </div>
                                <div class="col-span-8 sm:col-span-8">
                                    <breeze-label :value="'New Password'"/>
                                    <breeze-input required type="password" v-model="passwordForm.new_password" class="w-full"/>
                                    <breeze-input-error :message="passwordForm.errors.changePassword?passwordForm.errors.changePassword.new_password:''" />
                                </div>
                                <div class="col-span-8 sm:col-span-8">
                                    <breeze-label :value="'Password Confirmation'"/>
                                    <breeze-input type="password" required v-model="passwordForm.password_confirmation" class="w-full"/>
                                    <breeze-input-error :message="passwordForm.errors.changePassword?passwordForm.errors.changePassword.password_confirmation:''" />
                                </div>
                                
                            </div>
                            <breeze-button :disabled="passwordForm.processing">Save</breeze-button>
                            <exception />
                            <span v-show="passwordForm.recentlySuccessful" class="text-green-500 mx-4">Password Changed</span>
                        </form>
                    </div>
                </div>
            </div>
            
        </breeze-page>
    </breeze-authenticated-layout>
</template>

<script>
    import BreezeAuthenticatedLayout from '@/Layouts/Authenticated'
    import BreezePage from '@/Components/Page'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import BreezeButton from '@/Components/Button'
    import BreezeInputError from '@/Components/InputError'
    import ButtonLink from '@/Components/ButtonLink'
    import { useForm } from '@inertiajs/inertia-vue3'
    import Exception from '@/Components/Exception'
    import Loading from '@/Components/Loading'

    export default {
        components: {
            BreezeAuthenticatedLayout,
            BreezePage,
            BreezeInput,
            BreezeLabel,
            BreezeButton,
            BreezeInputError,
            ButtonLink,
            Exception,
            Loading
        },
        props:['user'],
        data() {
            return {
                form: useForm({
                    '_method':'PUT',
                    name: this.user.name,
                    mobile: this.user.mobile,
                    email: this.user.email,
                },{
                    errorBag:'profile'
                }),

                passwordForm: useForm({
                    '_method':'PUT',
                    old_password: '',
                    new_password: '',
                    password_confirmation: '',
                },{
                    errorBag:'changePassword'
                })
            }
        },
        methods: {
            submitForm() {
                this.form.post(route('profile.update'),{
                    preserveScroll: true
                });
            },
            changePassword() {
                this.passwordForm.post(route('profile.changepassword'),{
                    preserveScroll: true,
                    onSuccess: () => this.passwordForm.reset(),
                });
            },
        },
    }
</script>
